import React from 'react';
import { FormattedMessage, injectIntl } from '../../localization';
import { formattedServiceNames, prices } from '../../utils/configs';
import { useRootContext } from '../../providers/RootContext';

const ClearPricing = ({ className, intl }) => {
  const { serviceName } = useRootContext();
  const defaultMessages = {
    clearPricingBody: {
      id: 'clearPricingBody',
      defaultMessage:
        'Start your journey with a 3-day trial for just €{trialPrice}. After the trial, enjoy unlimited access to {serviceName} for €{subscriptionPrice}/month with auto-renewal. No hidden costs, all taxes are included in the price.'
    }
  };

  return (
    <div className={`clear-pricing card ${className || ''}`}>
      <h4>
        <FormattedMessage id="clearPricingTitle" defaultMessage="Clear and Transparent Prices" />
      </h4>
      <p>
        {intl
          .formatMessage(defaultMessages.clearPricingBody)
          .replace('{serviceName}', formattedServiceNames[serviceName])
          .replace('{trialPrice}', prices.trialPrice)
          .replace('{subscriptionPrice}', prices.subscriptionPrice)}
      </p>
    </div>
  );
};

export default injectIntl(ClearPricing);
